import { render, staticRenderFns } from "./DisplayStatusType.vue?vue&type=template&id=0e3124ff&"
import script from "./DisplayStatusType.vue?vue&type=script&lang=js&"
export * from "./DisplayStatusType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3124ff')) {
      api.createRecord('0e3124ff', component.options)
    } else {
      api.reload('0e3124ff', component.options)
    }
    module.hot.accept("./DisplayStatusType.vue?vue&type=template&id=0e3124ff&", function () {
      api.rerender('0e3124ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/DisplayStatusType.vue"
export default component.exports